import React from 'react';
import s from './NextSteps.scss';
import info from '../../../assets/images/icons/Info.svg';

const NextSteps = ({ email, className, title, step1, step2, step3, textEnd }) => {
    return (
        <div className={s.container}>
            <div className={`${s.card} ${className}`}>
                <div className={s.proximosPasos}>
                    <p className={s.title}>{title}</p>
                    <div><p className={s.number}>1</p><p className={s.text}>{step1}</p></div>
                    <div><p className={s.number}>2</p><p className={s.text}>{step2}</p></div>
                    <div className={s.lastLine}><p className={s.number}>3</p><p className={s.text}>{step3}</p></div>
                </div>
                <hr className={s.line}></hr>
                <div className={s.end}>
                    <img className={s.infoIcon} src={info} alt={"icono de información"}/>
                    <p className={s.textEnd}>{textEnd}{(email) && <strong style={{color: '#2377DB'}}>{email}</strong>}</p>
                </div>
            </div>
        </div>
    )
};
export default NextSteps;
